/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, ElementRef, EventEmitter, Input, Output, effect, inject } from '@angular/core';
import { DatePipe } from '@angular/common';

import * as noUiSlider from 'nouislider';

import { RegisterComponent } from '../component-lookup';
import { StateService } from '../../services/state.service';
import { DateService } from '../../services/date.service';

@RegisterComponent('DateSelector')
@Component({
  selector: 'app-date-selector',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './date-selector.component.html',
  styleUrl: './date-selector.component.scss'
})
export class DateSelectorComponent {
  @Input() periods: number = 13;
  @Input() globalState = true;
  @Output() dateChange = new EventEmitter<Date>();
  private stateService = inject(StateService);
  private dateService = inject(DateService);

  el = inject(ElementRef);
  datepipe: DatePipe = new DatePipe('en-us');

  date: Date = new Date();
  dates: Date[] = [];
  sliderElem: any;
  slider?: any;
  tooltips: any;
  origins: any;

  constructor() {
    effect(() => {
      const institution = this.stateService.institution();
      if (institution && this.dateService.datesFetched()) {
        // globals
        this.dates = this.dateService.getDates(institution.institutionType);
        this.dates = this.dates.slice(Math.max(this.dates.length - this.periods, 0));

        const date = this.stateService.date();
        this.date = date ?? this.dates[this.dates.length - 1]

        const start = this.dates.findIndex(d => d.getTime() == this.date.getTime());
        const min = 0;
        const max = this.dates.length - 1;

        setTimeout(() => {
          this.initSlider(start, min, max);
        });
      }
    });
  }

  initSlider(start: number, min: number, max: number) {
    const pips: any = {
      mode: 'steps',
      density: 100,
      filter: function () { return ''; }
    }

    const config: any = {
      keyboardPageMultiplier: 4,
      margin: 1,
      start: start,
      range: {
        'min': min,
        'max': max
      },
      step: 1,
      connect: true,
      behaviour: 'tap-drag',
      tooltips: {
        to: (value: number) => {
          if (this.dates) {
            return this.datepipe.transform(this.dates[Math.round(value)], 'MMM yyyy') ?? '';
          }
          else {
            return '';
          }
        }
      },
      pips: pips
    };

    this.sliderElem = this.el.nativeElement.querySelector('#slider');

    if (this.sliderElem.noUiSlider) {
      this.sliderElem.noUiSlider.destroy();
    }

    noUiSlider.create(this.sliderElem, config);
    this.slider = this.sliderElem.noUiSlider;

    this.slider.on('change', (values: any) => {
      this.onChange(values);
    });

    this.dateChange.emit(this.date);
    if (this.globalState) {
      this.stateService.setDate(this.date);
    }
  }

  public onChange(value: number) {
    this.date = this.dates[Number(value)];
    this.dateChange.emit(this.date);
    if (this.globalState) {
      this.stateService.setDate(this.date);
    }
  }
}
